var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.delete_editor)?_c('EmailEditor',{ref:"emailEditor",attrs:{"appearance":_vm.appearance,"min-height":_vm.minHeight,"project-id":_vm.projectId,"locale":_vm.locale,"options":_vm.options},on:{"load":_vm.editorLoaded}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }